export class CalenderData {
  public Id: number;
  public Day: string;
  public ArrStaLastLeg = '';
  public DepTimeFirstLeg = '';
  public LandTimeLastLeg = '';
  public TripNumber = '';
  public StartDay = '';
  public isStrikeNeededForTop: boolean;
  public isStrikeNeeded: boolean;
  public isStrikeNeededForBottom: boolean;
  public color: string;
  public IsEnabled: boolean;
  public ColorTop = '';
  public ColorBottom = '';
  public ArrStaLastLegDecoration: boolean;
  public LandTimeLastLegDecoration: boolean;
  public DepTimeFirstLegDecoration: boolean;
  public DateStr: string;
}
